module.exports = __webpack_public_path__ + "img/Current Icon.3b471dd8.png";